export function getCognitoUserPoolEndpoint(
	endpoint: string,
	origin: string,
): string {
	return endpoint.startsWith("/") ? new URL(endpoint, origin).href : endpoint;
}
